import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';

const white = new HSLColor(0, 0, 1);

const color = ({ backgroundColor, whiteColor, blackColor, surfaceColor }) => {
  const ratio = contrastRatio(backgroundColor, white, { surfaceColor });
  return ratio >= 3 ? whiteColor : blackColor;
};

export default color;
